import { render, staticRenderFns } from "./NextSteps.vue?vue&type=template&id=6953b034&scoped=true"
import script from "./NextSteps.vue?vue&type=script&lang=js"
export * from "./NextSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953b034",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6953b034')) {
      api.createRecord('6953b034', component.options)
    } else {
      api.reload('6953b034', component.options)
    }
    module.hot.accept("./NextSteps.vue?vue&type=template&id=6953b034&scoped=true", function () {
      api.rerender('6953b034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/contextualSearch/NextSteps.vue"
export default component.exports